// @flow

import * as React from 'react'
import { Popup, Button } from 'semantic-ui-react'

type OwnProps = {|
  showWeb: boolean,
  showPhone: boolean,
  showF2F: boolean,
  webLabel: string,
  phoneLabel: string,
  f2fLabel: string,
  onToggleFilter: (filter: 'web' | 'phone' | 'f2f') => void,
|}

class ChartFilterToolbar extends React.Component<OwnProps> {
  static defaultProps = {
    onToggleFilter: () => {},
    webLabel: 'Web',
    phoneLabel: 'Phone',
    f2fLabel: 'F2F',
  }
  render() {
    let baseProps = {
      inverted: true,
      position: 'bottom left',
    }
    return (
      <span>
        <Popup
          trigger={
            <Button
              icon={this.props.showWeb ? 'checkmark box' : 'square outline'}
              labelPosition="right"
              content={this.props.webLabel}
              value="web"
              color="blue"
              style={{ minWidth: '15ex', opacity: this.props.showWeb ? 1 : 0.6 }}
              size="small"
              onClick={() => this.props.onToggleFilter('web')}
            />
          }
          content={this.props.showWeb ? 'Nascondi Web' : 'Mostra Web'}
          {...baseProps}
        />
        <Popup
          trigger={
            <Button
              icon={this.props.showF2F ? 'checkmark box' : 'square outline'}
              labelPosition="right"
              content={this.props.f2fLabel}
              value="f2f"
              color="green"
              style={{ minWidth: '15ex', opacity: this.props.showF2F ? 1 : 0.6 }}
              size="small"
              onClick={() => this.props.onToggleFilter('f2f')}
            />
          }
          content={this.props.showF2F ? 'Nascondi F2F' : 'Mostra F2F'}
          {...baseProps}
        />
        <Popup
          trigger={
            <Button
              icon={this.props.showPhone ? 'checkmark box' : 'square outline'}
              labelPosition="right"
              content={this.props.phoneLabel}
              value="phone"
              color="orange"
              style={{ minWidth: '15ex', opacity: this.props.showPhone ? 1 : 0.6 }}
              size="small"
              onClick={() => this.props.onToggleFilter('phone')}
            />
          }
          content={this.props.showPhone ? 'Nascondi Phone' : 'Mostra Phone'}
          {...baseProps}
        />
      </span>
    )
  }
}

export default ChartFilterToolbar



// WEBPACK FOOTER //
// ./src/reports/chart-filter-toolbar.js